import React, { useState, useContext, useEffect } from "react";

// react-pdf issue https://github.com/wojtekmaj/react-pdf/issues/991
import { Document, Page, pdfjs } from "react-pdf";
import {
  Box,
  Button,
  Card,
  Dialog,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import { Add, Remove } from "@mui/icons-material";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewerV2 = (props) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1);
  const [fullScreen, setFullScreen] = useState(false);
  const { fileUri, downloadName } = props;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  return (
    <Box
      sx={{
        paddingTop: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              setPageNumber((prev) => (prev > 1 ? prev - 1 : prev));
            }}
          >
            Previous
          </Button>
          <Typography>
            Page {pageNumber} of {numPages}
          </Typography>
          <Button
            onClick={() => {
              setPageNumber((prev) => (prev < numPages ? prev + 1 : prev));
            }}
          >
            Next
          </Button>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              // using Java Script method to get PDF file
              fetch(fileUri).then((response) => {
                response.blob().then((blob) => {
                  console.log("BLOB", blob);
                  // Creating new object of PDF file
                  const fileURL = window.URL.createObjectURL(blob);
                  // Setting various property values
                  let alink = document.createElement("a");
                  alink.href = fileURL;
                  alink.download = downloadName ? downloadName : "file.pdf";
                  alink.click();
                });
              });
            }}
          >
            Download
          </Button>
        </Box>

        <Box
          style={{
            flex: 1,
            // width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Button
            onClick={() => {
              setScale((prev) => (prev > 0.5 ? prev - 0.1 : prev));
            }}
          >
            <Remove />
          </Button>
          <Typography>ZOOM</Typography>

          <Button
            onClick={() => {
              setScale((prev) => (prev < 3 ? prev + 0.1 : prev));
            }}
          >
            <Add />
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          // maxHeight: "600px",
          width: "100%",
          background: "#d3d3d3",
          margin: "16px",
          //   overflowX: "scroll",
          //   overflowY: "scroll",
        }}
      >
        <Document
          file={fileUri}
          onLoadSuccess={onDocumentLoadSuccess}
          onClick={() => {
            setFullScreen(true);
          }}
        >
          <Page pageNumber={pageNumber} scale={scale} />
        </Document>
      </Box>
    </Box>
  );
};

export default PdfViewerV2;
